import { useMemo } from 'react'
import { getNestedObject, isArray } from '../../fns'

const useCommonOptions = (member, country, dataset) => {
  const { type, material, width, depth, isRough } = member

  const getOptionsByKey = (opts, ...keys) => (isArray(opts) ? opts : getNestedObject(opts, keys))

  const materialOptions = useMemo(() => {
    const data = dataset.materialData[type]
    return data ? getOptionsByKey(data, [country]) : []
  }, [type, country])

  const widthOptions = useMemo(() => {
    const data = dataset.widthData.find(
      (item) => item.type === type && item.material.includes(material),
    )

    return data
      ? getOptionsByKey(data.options, [type === 'psl' ? country : isRough ? 'rough' : 'default'])
      : []
  }, [type, material, isRough, country])

  const depthOptions = useMemo(() => {
    const data = dataset.depthData.find(
      (item) =>
        item.type === type &&
        item.material.includes(material) &&
        // TODO: Need to have dynamic condition for dependent data
        (item.width || [width]).includes(width),
    )
    return data ? getOptionsByKey(data.options, [isRough ? 'rough' : 'default']) : []
  }, [type, material, width, isRough])

  const pliesOptions = useMemo(() => {
    const data = dataset.pliesData.find(
      (item) =>
        item.type === type &&
        item.material.includes(material) &&
        // TODO: Need to have dynamic condition for dependent data
        (item.width || [width]).includes(width) &&
        (item.depth || [depth]).includes(depth),
    )
    return data ? getOptionsByKey(data.options, []) : []
  }, [type, material, width, depth])

  const thicknessOptions = useMemo(() => {
    const data = (dataset.thicknessData || []).find(
      (item) => item.type === type && item.material.includes(material),
    )

    return data ? getOptionsByKey(data.options, []) : []
  }, [type, material])

  return {
    materialOptions,
    widthOptions,
    depthOptions,
    pliesOptions,
    thicknessOptions,
  }
}

export default useCommonOptions
